import MyPluginsIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import usePageTitle from '@/hooks/usePageTitle';
import MyPluginsSection from '@/sections/plugins/myPlugins/MyPluginsSection';

const MyPlugins = () => {
  usePageTitle('Integraciones - Mis plugins');

  return (
    <Container maxWidth="xxl">
      <header className="mt-5 mb-8 flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <MyPluginsIcon fontSize="large" color="secondary" />
          <Typography variant="h4" color="secondary" fontWeight={700}>
            Plugins
          </Typography>
        </div>
      </header>
      <MyPluginsSection />
    </Container>
  );
};

export default MyPlugins;
